module.exports = new __parcel__URL__("space-cloud-2.3eb4d1ff.webp").toString();